import { Layout } from 'src/components/layout/layout';
import Analog from 'src/components/AnalogInventory';


const AnalogInventory = () => {
    return <Layout>
        <Analog />
    </Layout>;
};

export default AnalogInventory;
